var lib_core = require("lib-core");
var THREE                    = require("three");

/**
 * @constructor
 */
var Selection3dStateMachine = function (model) {
    var self = this; 
    this.model = model;

    lib_core.StateMachine.call(this);

    this.lastHoverModel = null;

    // SELECT NEW ITEM
    this.addTransition("idle","idle",
        function(cEvent){
            // if element is selectable and not already selected
            return ( cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN 
                    && cEvent.element() && cEvent.element().selectable
                    && !cEvent.element().selected() )
        },
        function(cEvent){
            self.model.deselectAll(); // for now limit to 1 selection
            self.model.select(cEvent.element());
            self.model.lastSelectionPoint = cEvent.data("mousePoint");

            // handle incase desired moving also
            self.handle(cEvent);
        }
    );

    // TELL ITEM ITS HOVERED 
    this.addTransition("idle","idle",
        function(cEvent){
            // if element is selectable and not already selected
            return ( cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE )
        },
        function(cEvent){

            // TODO clean this up!!  its gross
            if(cEvent.element()){// hovering over something
                // if new hover is different than old
                if(self.lastHoverModel && cEvent.element() != self.lastHoverModel){
                    self.setHover(self.lastHoverModel, false);
                 }
               
                // hover new
                if(cEvent.element().hoverable){
                    self.setHover(cEvent.element(), true);
                    self.lastHoverModel = cEvent.element();
                }

            } else {
                // not hovering over anything
                if(self.lastHoverModel){
                    self.setHover(self.lastHoverModel, false);
                    self.lastHoverModel = null;
                }
            }
        }
    );

};

lib_core.inherit(Selection3dStateMachine, lib_core.StateMachine);

// set hover, and if handle, tell the subjects that its handle is hovered
Selection3dStateMachine.prototype.setHover = function(model, bool){
    if(!model || !model.hoverable) return;
    model.hovered(bool); // deselect old
    if(model.isHandle){
        model.subjects.forEach(function(id, subject){
            if(subject.handlesHovered){
                subject.handlesHovered(bool);
            }
        });
    }
}


module.exports = Selection3dStateMachine;


